import makeApi from "../../libs/axios/api";

export type InvoiceResponse = {
  data: {
    fileBase64Content: string;
  };
};

const apiPromise = makeApi();

export const fetchInvoiceAPI = async (
  orderId: string
): Promise<InvoiceResponse> => {
  const api = await apiPromise;
  try {
    const response = await api.get(`/order/${orderId}/Invoice`);
    return response;
  } catch (error: any) {
    const errorMsg =
      error?.response?.data?.message || error.message || "Something went wrong";
    throw new Error(errorMsg);
  }
};
